export class UsuarioAutorizadoModel {
    nomusuario: string;
    pass: string;
}
